module.exports = __webpack_public_path__ + "media/images/lb/482-3220858df4d0060a0b593dca04038b81.svg";